import { computable, observable } from "@chorda/core";
import { Index } from "flexsearch";
import { MdnSearchSimple } from "./simple";
import { Lazy } from "./lazy";
const MdnSearchLazy = () => import("./search").then(m => m.MdnSearch);
const MDN_SEARCH_INDEX = require('../../../data/mdn-search-index.json');
export default () => {
    return {
        tag: 'form',
        styles: {
            height: 400
        },
        templates: {
            search: Lazy({
                lazy: MdnSearchLazy,
                initial: MdnSearchSimple({
                    placeholder: 'Go ahead. Type your search...',
                    value$: $ => $.query,
                    onFocus: (e, { loadLazy }) => {
                        loadLazy();
                    },
                    onInput: (e, { updateSelection }) => {
                        const el = e.currentTarget;
                        updateSelection(el.selectionStart, el.selectionEnd);
                    }
                }),
            }),
        },
        events: {
            $dom: {
                submit: (e, {}) => {
                    e.preventDefault();
                    // TODO здесь загружаем страницу
                },
            },
        },
        defaults: {
            query: () => observable(''),
            flex: () => new Index({ tokenize: 'forward' }),
            db: () => observable([]),
            textSelection: () => observable([0, 0])
        },
        injections: {
            suggest: $ => computable(() => {
                const indexes = $.flex.search($.query, {
                    limit: 5,
                });
                return indexes.map((i) => $.db.$value[i]);
            }),
            updateSelection: $ => (start, end) => {
                $.textSelection.$value = [start, end];
            }
        },
        joints: {
            loadAndBuildIndex: ({ flex, db }) => {
                setTimeout(() => {
                    const data = MDN_SEARCH_INDEX.map(v => { return Object.assign(Object.assign({}, v), { id: v.url }); });
                    data.forEach(({ title }, i) => {
                        flex.add(i, title);
                    });
                    db.$value = data;
                    //search.$value = 'read'
                }, 500);
            }
        }
    };
};
